var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"growth-box"},[_c('YearSelector',{on:{"select":_vm.select}}),_c('StandardChart',{staticClass:"my-3",attrs:{"input":_vm.userData,"chartType":"bar"}}),_c('StandardChart',{staticClass:"my-5",attrs:{"input":_vm.starData,"chartType":"bar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }